export default __webpack_public_path__ + "static/media/slippers.d0b7bbcc.png";